import React, { useState } from "react"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"

//Import Breadcrumb
import { PageContent, CustomBreadcrumb } from "components/Common"

import CardDetail from "./CardDetail"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.DeliveryManagement

const DetailContainer = ({ isEdit, t }) => {
  const titleTag = `Delivery Detail`
  const [sticky, setSticky] = useState(false);
  return (
    <PageContent title={titleTag}>
      <CustomBreadcrumb
        breadcrumbItem={t("Delivery Management")}
        resource={RESOURCE}
        isDetail
        tab={'1'}
        onSticky={(e) => {
          setSticky(e)
        }}
      />
      <CardDetail isEdit={isEdit} sticky={sticky} />
    </PageContent>
  )
}

DetailContainer.propTypes = {
  t: PropTypes.any,
  isEdit: PropTypes.bool,
}

export default withTranslation(["deliveryPage"])(DetailContainer)
